import React, { useEffect } from 'react';

export function ForceReloadOnBack() {
  useEffect(() => {
      (function () {
        window.onpageshow = function(event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
      })();
  }, []);

  return null;
}
